import { useEffect, useRef, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import LabelForm from './formElements/LabelForm'
import LabelList from './listElements/listElements'
import * as XLSX from 'xlsx'

const Tools = () => {
  const [letterClass, setLetterClass] = useState('text-animate')
  const [activeState, setActiveState] = useState('label')
  const [labelList, setLabelList] = useState([])
  const fileInputRef = useRef(null)

  useEffect(() => {
    setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 4000)
  }, [])

  const handleButtonClick = () => {
    fileInputRef.current.click()
  }
  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (!file) return
    const reader = new FileReader()
    reader.onload = (event) => {
      const binaryStr = event.target.result
      const workbook = XLSX.read(binaryStr, { type: 'binary' })
      const sheetName = workbook.SheetNames[0]
      const sheet = workbook.Sheets[sheetName]
      const jsonData = XLSX.utils.sheet_to_json(sheet)

      const newLabels = jsonData.map((data) => ({
        UPC: data.barcode_text,
        TITLE: data.title,
        CN_TITLE: data.desc,
        SIZE: data.size_text,
        UNIT: data.unit ? `PER - ${data.unit}` : 'PER - OZ',
        PRICE: data.price,
      }))

      setLabelList((prev) => [...prev, ...newLabels])
    }
    reader.readAsArrayBuffer(file)
    e.target.value = ''
  }

  const genPdf = async (e) => {
    e.preventDefault()
    let res
    try {
      res = await fetch(
        'https://pdf-label-generator-668455310347.us-central1.run.app/gen-pdf',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(labelList),
        }
      )
    } catch (error) {
      console.log(error)
    }

    const blob = await res.blob()
    const blobUrl = URL.createObjectURL(blob)
    window.open(blobUrl)
  }

  const onAdd = (data) => {
    setLabelList((prev) => [...prev, data])
    console.log('Added:', data)
  }

  const onDelete = (index) => {
    const newList = [...labelList]
    newList.splice(index, 1)
    setLabelList(newList)
  }

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={'TOOLS'.split('')}
              idx={15}
            />
          </h1>

          <div className="btn-gp">
            <button
              className={`flat-button ${
                activeState === 'label' ? 'active' : ''
              }`}
              onClick={() => setActiveState('label')}
            >
              LABEL
            </button>
            <button
              className={`flat-button ${activeState === 'pdf' ? 'active' : ''}`}
              onClick={() => setActiveState('pdf')}
            >
              PDF SPLITTER
            </button>
          </div>

          <div className="form-list-container">
            <div className="contact-form">
              {/* --labelForm-- */}
              <LabelForm onAdd={onAdd} />
              {/* --labelForm-- */}
            </div>
          </div>
          <div className="btn-gp">
            <button
              type="submit"
              className="flat-button-right"
              onClick={genPdf}
            >
              GEN PDF
            </button>
          </div>

          <div className="btn-gp">
            <button
              type="button"
              className="flat-button-left"
              onClick={handleButtonClick}
            >
              FILE UPLOAD
            </button>

            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </div>
        </div>

        {/* list elements */}
        <LabelList
          labelList={labelList}
          onDelete={onDelete}
          className="labelList-playground"
        />
        {/* list elements */}
      </div>

      <Loader type="line-scale-pulse-out-rapid" />
    </>
  )
}

export default Tools
